import { useStepperStore } from "@/store/stepper";

/** Adventure 102 and its clones: 103 (the mock fixture) and 108 (Jian's
 *  mission-steps trial on staging), where every change since lands. */
export const COMPANION_ADVENTURES = [102, 103, 108];

export function companionEnabledFor(
  adventureId: string | number,
  enabled = import.meta.env.VITE_HANDLER_COMPANION === "1",
) {
  return enabled && COMPANION_ADVENTURES.includes(Number(adventureId));
}
export function useHandlerCompanionEnabled() {
  const adventureId = useStepperStore((s) => s.adventureId);
  return companionEnabledFor(adventureId);
}
